import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function onClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  return (
    <div ref={ref} className="relative w-full max-w-md">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-3 rounded-full border border-background-200 bg-background-50 px-5 py-3.5 text-left cursor-pointer transition-colors hover:border-background-300"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="flex items-center gap-2.5 text-sm font-medium text-foreground-700">
          <span className="flex h-5 w-5 items-center justify-center text-primary-600">
            <i className="ri-grid-line text-lg leading-none"></i>
          </span>
          {t('hero.dropdownLabel')}
        </span>
        <span className="flex h-5 w-5 items-center justify-center text-foreground-500">
          <i className={`text-lg leading-none ${open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}></i>
        </span>
      </button>

      {open && (
        <ul
          className="absolute left-0 right-0 z-50 mt-2 max-h-80 overflow-y-auto rounded-lg border border-background-200 bg-background-50 py-1"
          role="listbox"
        >
          {categories.map((c) => (
            <li key={c.id}>
              <a
                href={c.url}
                target="_blank"
                rel="noopener nofollow"
                role="option"
                className="flex items-center justify-between px-5 py-3 text-sm text-foreground-800 transition-colors hover:bg-primary-50 cursor-pointer whitespace-nowrap"
              >
                <span>{t(`categories.${c.id}`)}</span>
                <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
                  <i className="ri-external-link-line text-base leading-none"></i>
                </span>
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}